import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard } from 'lucide-react';
import { CTAButton, CHECKOUT_URL, PRICE_USD } from './Shared';
const heroImage = {
  src: 'https://cdn.magicpatterns.com/uploads/kRZUd8bNEGVCswjSgsEGvj/Mockup_con_buena_calidad_sin_fondo.png',
  alt: 'Mega Pack Chi Kung: los 3 tomos, las plantillas clínicas y los 6 bonus de regalo'
};
const badges = [{
  emoji: '📘',
  label: '100% PDF'
}, {
  emoji: '⚡',
  label: 'Acceso en 5 minutos'
}, {
  emoji: '🧘',
  label: 'Todos los niveles'
}];
export const Hero = () => {
  return <header className="relative overflow-hidden" data-id="element-97" data-mp="sbb2vha3iedu">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-98" data-mp="s9zxxe4wz0l5">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[760px] h-[760px] max-w-[130vw] rounded-full bg-brand-goldLight/25 blur-[150px]" data-id="element-99" data-mp="nbewjbdxeav4"><div className="flex w-full shrink-0 flex-wrap items-center justify-center gap-1.5 md:gap-3 text-[10px] sm:text-xs md:text-sm" style={{
          width: "328px",
          height: "57px"
        }} data-id="element-100" data-mp="382p73hcojln9">
          {badges.map(({
            emoji,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 bg-brand-paper border border-brand-purpleDark/10 px-2.5 py-1 md:px-3 md:py-1.5 rounded-sm whitespace-nowrap text-brand-textLight" data-id="element-101" data-mp="3o5j1b4tkf9j6">
              <span aria-hidden="true" data-id="element-102" data-mp="3eb9150ydt6xw">{emoji}</span>
              {label}
            </span>)}
        </div></div>
        <div className="absolute top-16 right-[3%] font-display text-[96px] md:text-[170px] leading-none text-brand-purpleDark/[0.06] select-none animate-float-soft" style={{
        animationDelay: '0.8s'
      }} data-id="element-103" data-mp="358rfooqjwiby">
          氣
        </div>
        <div className="absolute bottom-16 left-[3%] font-display text-[80px] md:text-[140px] leading-none text-brand-purpleDark/[0.05] select-none animate-float-soft" style={{
        animationDelay: '2s'
      }} data-id="element-104" data-mp="2vjpxqt0g3qvc">
          和
        </div>
        <div className="hidden lg:block absolute top-[18%] left-[4%] w-56 h-56 rounded-full border border-brand-gold/25" data-id="element-105" data-mp="2lml8gkbazfab" />
        <div className="hidden lg:block absolute bottom-[12%] right-[4%] w-48 h-48 rounded-full border border-brand-purpleDark/10" data-id="element-106" data-mp="nbl0ygmt488c" />
      </div>

      {/* Above the fold: headline, mockup and CTA — no scroll needed on mobile */}
      <motion.div initial={{
      opacity: 0,
      y: 14
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.7
    }} className="relative z-10 mx-auto flex min-h-[calc(100svh-44px)] w-full max-w-6xl flex-col items-center justify-center gap-[0.9vh] px-3 py-2 text-center sm:px-6 md:min-h-0 md:gap-6 md:py-14" style={{
      paddingTop: "6px"
    }} data-id="element-107" data-mp="de6rj0zawjpj">
        <div className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full border border-brand-gold/60 bg-brand-paper/80 px-4 py-1.5 shadow-sm" style={{
        width: "210px",
        height: "26px"
      }} data-id="element-108" data-mp="114kkctppmml6">
          <span aria-hidden="true" className="text-sm" data-id="element-109" data-mp="3hrllolqr8dak">
            🌿
          </span>
          <span className="font-seal text-[10px] md:text-xs uppercase tracking-seal text-brand-goldDark" data-id="element-110" data-mp="1x9b3owgzwtag">
            Lumen Akasha™
          </span>
        </div>

        {/* Exactly two lines, at every width */}
        <h1 className="shrink-0 font-display font-bold text-brand-purpleDark" style={{
        fontSize: 'clamp(2.1rem, 8.7vw, 5rem)',
        lineHeight: 1,
        letterSpacing: '-0.02em'
      }} data-id="element-111" data-mp="26a98hgz9d4u3">
          <span className="block whitespace-nowrap" style={{
          fontSize: "40px",
          width: "336px",
          height: "28px"
        }} data-id="element-112" data-mp="2fzsu2uecvcsn">
            Sesiones más{' '}
            <span className="relative inline-block" data-id="element-113" data-mp="2kxc9hxmshvm6">
              <span aria-hidden="true" className="absolute inset-x-[-4px] bottom-[0.08em] h-[0.26em] bg-brand-goldLight/60" data-id="element-114" data-mp="2ozz4u8io5yo4" />
              <span className="relative" data-id="element-115" data-mp="2tyadifx8a34r">efectivas</span>
            </span>
          </span>
          <span className="block whitespace-nowrap" style={{
          fontSize: "40px"
        }} data-id="element-116" data-mp="unj1pgl670nh">y sin improvisar.</span>
        </h1>

        <p className="mx-auto max-w-[30ch] shrink-0 font-display italic text-brand-textLight/85" style={{
        fontSize: "24px",
        lineHeight: 1.18,
        height: "8px"
      }} data-id="element-117" data-mp="zlsx9sat439m">
          El conocimiento ya lo tienes. El sistema para aplicarlo, ahora
          también.
        </p>

        {/* Mockup: full width, only the empty bottom margin is trimmed so the
            CTA can sit right under the pack. */}
        <div className="w-full min-h-0 flex-1 overflow-hidden sm:max-w-xl md:max-w-[42rem] md:flex-none md:h-[36vh]" data-id="element-118" data-mp="9b0atrhultyh">
          <img src={heroImage.src} alt={heroImage.alt} className="h-full w-full object-cover object-top drop-shadow-2xl" draggable={false} decoding="async" style={{
          height: "436px"
        }} data-id="element-119" data-mp="3ho69eirr426i" />
        </div>

        <p className="mx-auto max-w-[34ch] shrink-0 font-display font-semibold text-brand-purpleDark text-[16px] leading-snug sm:text-lg md:text-xl" style={{
        fontSize: "24px",
        fontWeight: "400",
        width: "338px"
      }} data-id="element-120" data-mp="3ri6h8sef3lix">
          Pasa de la planificación caótica a una práctica clínica profesional
          hoy mismo. 🧘‍♂️
        </p>

        <div className="flex w-full shrink-0 flex-col items-center gap-[0.9vh] md:gap-4" data-id="element-121" data-mp="19i5fcl09zci7">
          <CTAButton variant="purple" href={CHECKOUT_URL} className="w-full max-w-md rounded-full cta-shimmer relative overflow-hidden ring-1 ring-brand-goldLight/50 hover:ring-brand-goldLight" style={{
          fontSize: 'clamp(1.05rem, 4.6vw, 1.5rem)',
          paddingTop: 'clamp(1rem, 2.4svh, 1.5rem)',
          paddingBottom: 'clamp(1rem, 2.4svh, 1.5rem)'
        }} data-id="element-122" data-mp="1e93ydscneop5">
            <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-123" data-mp="1s9y6e9vsanna">
              Quiero mi Mega Pack — {PRICE_USD}
              <span aria-hidden="true" data-id="element-124" data-mp="1j8gsmy5umy1r">→</span>
            </span>
          </CTAButton>

          <ul className="flex w-full max-w-md items-stretch justify-center divide-x divide-brand-gold/30 rounded-full border border-brand-gold/40 bg-brand-paper/70 text-brand-textLight" data-id="element-125" data-mp="1jat7v3k82ub4">
            {[{
            emoji: '💳',
            label: 'Pago único'
          }, {
            emoji: '⚡',
            label: 'Acceso inmediato'
          }, {
            emoji: '🛡️',
            label: 'Garantía 7 días'
          }].map(({
            emoji,
            label
          }) => <li key={label} className="flex flex-1 flex-col items-center gap-0.5 px-2 py-2 text-[11px] leading-tight md:text-[13px]" data-id="element-126" data-mp="29hxtudclu0rp">
                <span aria-hidden="true" className="text-sm md:text-base" data-id="element-127" data-mp="24q6bur7il3d6">
                  {emoji}
                </span>
                <span className="font-medium" data-id="element-128" data-mp="1zqtp06gn7wal">{label}</span>
              </li>)}
          </ul>
        </div>
      </motion.div>

      {/* Below the fold: supporting detail */}
      
    </header>;
};